<div
  class="search-box"
  [class.searchBox--focus]="focused || searchBox.length > 0"
  [class.search-box--wide]="ppSize === 'wide'"
>
  @if (!focused && searchBox.length === 0) {
    <pp-icon [ppSVG]="iconMap[EIconPath.ICON_NAV_SEARCH_14]" ppColor="grey-600" />
  }

  <input
    #input
    (ppOnRendered)="onInputRendered($event)"
    id="searchBoxKeywords"
    class="searchInput input"
    aria-label="search box"
    name="filter-text"
    type="text"
    [placeholder]="ppPlaceholder"
    [(ngModel)]="searchBox"
    (focus)="onInputFocus()"
    (focusout)="onInputBlur()"
    (keyup)="filterItems()"
    (keydown.enter)="onEnter()"
    [style.color]="ppColor"
  />

  <div class="closeIcon__wrapper">
    @if (searchBox.length > 0) {
      <img
        id="searchInputKeywordsClear"
        class="closeIcon"
        [src]="EIconPath.INTERACTION_DELETE_TEXT"
        (click)="clear()"
        aria-label="Search input clear"
      />
    }
  </div>
</div>
